import { LoaderDataPage } from "~/data/loaders/page";

// ✅ Generic type guard to check for any template type
export function isTemplateType<T extends string>(
  template: unknown,
  templateType: T
): template is { _type: T } {
  return (
    template !== undefined &&
    template !== null &&
    typeof template === "object" &&
    "_type" in template &&
    (template as { _type: string })._type === templateType
  );
}

// ✅ Utility type to extract a specific template by `_type`
export type ExtractTemplateByType<
  Data extends LoaderDataPage,
  T extends string
> = Extract<
  NonNullable<
    Extract<
      Data["page"]["data"],
      { template: NonNullable<unknown> | null }
    >["template"]
  >,
  { _type: T }
>;

export type PageData = LoaderDataPage["page"]["data"];

// Research
export type TemplateArchiveResearchLibrary = ExtractTemplateByType<
  LoaderDataPage,
  "templateArchiveResearchLibrary"
>;

export type ArchiveResearch = NonNullable<LoaderDataPage["research"]>;

export type DocumentResearchPaper = ArchiveResearch["items"][number];

// Filters

export type Filters = ArchiveResearch extends { filters: infer F } ? F : unknown;

export type FiltersPagination = ArchiveResearch extends { pagination: infer P }
  ? P
  : unknown;

// Components

export type HeroSecondary = TemplateArchiveResearchLibrary["heroSecondary"];

// Team Landing
export type TemplateArchiveTeamLanding = ExtractTemplateByType<
  LoaderDataPage,
  "templateArchiveTeamLanding"
>;

// Research Group
export type TemplateGetInvolved = ExtractTemplateByType<
  LoaderDataPage,
  "templatePageGetInvolved"
>;
